"use strict";
// Copyright © 2021 Move Closer
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Block = void 0;
const Block_1 = __importDefault(require("./Block"));
exports.Block = Block_1.default;
exports.default = Block_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9CbG9jay9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsK0JBQStCOzs7Ozs7QUFFL0Isb0RBQTJCO0FBRWxCLGdCQUZGLGVBQUssQ0FFRTtBQUNkLGtCQUFlLGVBQUssQ0FBQSIsInNvdXJjZXNDb250ZW50IjpbIi8vIENvcHlyaWdodCDCqSAyMDIxIE1vdmUgQ2xvc2VyXG5cbmltcG9ydCBCbG9jayBmcm9tICcuL0Jsb2NrJ1xuXG5leHBvcnQgeyBCbG9jayB9XG5leHBvcnQgZGVmYXVsdCBCbG9ja1xuIl19